import { ApolloLink } from "@apollo/client";
import { getMainDefinition } from "@apollo/client/utilities";
import * as Sentry from "@sentry/react";
import { map } from "rxjs";

function isMutation({ query }) {
  const definition = getMainDefinition(query);

  return definition.kind === "OperationDefinition" && definition.operation === "mutation";
}

function getMutationMainReturn({ query }) {
  const definition = getMainDefinition(query);

  if (definition.kind === "OperationDefinition" && definition.operation === "mutation") {
    return definition.selectionSet.selections[0].name.value;
  }
  return null;
}

export default function createGenericMutationErrorLink(setShowGenericError) {
  return new ApolloLink((operation, forward) =>
    forward(operation).pipe(
      map((data) => {
        // Called after server responds
        if (isMutation(operation)) {
          const mutationReturnName = getMutationMainReturn(operation);

          if ((!data.data || !data.data[mutationReturnName]) && !data.errors) {
            Sentry.captureMessage(`Mutation Error: ${operation.operationName}`, {
              extra: {
                operationName: operation.operationName,
                variables: operation.variables,
              },
            });

            setShowGenericError(true);
          }
        }

        return data;
      }),
    ),
  );
}
